/*
  ----------------------------------------------------------------------------------------------------------------------
  NDP - COLLEZIONI: scorciatoie "Abbina con" + "altri 50 capi" allo scorrimento      Noi da piccoli, 2026-09-25, v4.8
  ----------------------------------------------------------------------------------------------------------------------
  Caricato una volta (defer) da sections/main-collection.liquid. Nessuna dipendenza, nessun lavoro all'apertura
  della pagina oltre ad agganciare due osservatori: tutto il resto parte dopo il caricamento o solo se l'utente scorre.

  1. SCORCIATOIE (sections/ndp-collection-header.liquid, [data-ndp-colnav])
     - Conta i capi disponibili di ogni scorciatoia con la stessa vista del wizard (?view=wizard-exact, risposta di
       pochi byte), dopo il load della pagina, a 3 per volta, fermandosi appena ne bastano N. Riusa i conteggi gia'
       fatti dal menu (ndp_menu_counts, stessa forma di URL) e i propri (ndp_colnav_counts), in sessionStorage.
     - Conta l'href DEFINITIVO: il menu (applySeason() in snippets/header-sidebar.liquid) porta ogni link della pagina
       alla stagione scelta dal visitatore; a un cambio stagione (evento ndp:state-changed) si riconta, se la pagina
       e' ancora qui dopo 1,5 s (su una collezione del wizard il wizard naviga subito alla stagione nuova).
     - Se la taglia cambia dai filtri laterali di Prestige (la griglia si aggiorna senza ricaricare l'intestazione),
       riscrive le scorciatoie con le stesse regole del Liquid: eta' della pagina, 0-6 mesi per Uscita clinica e
       Corredino, niente eta' per le voci senza taglia, voci 0-6 mesi spente se l'eta' non e' compatibile.
     - Tiene le prime N con almeno "min" capi; se un conteggio fallisce o supera 8 secondi la scorciatoia resta
       (fail-open, come wizard e menu).

  2. ALTRI 50 CAPI (snippets/ndp-collection-pager.liquid, [data-ndp-more])
     - Quando la griglia supera il 60% (il 30esimo capo su 50 entra nello schermo, con 400px di anticipo) scarica
       la pagina successiva con la Section Rendering API e ne aggiunge i capi in fondo: 100 capi per pagina,
       pagine dimezzate. L'apertura della pagina non cambia: il secondo blocco lo scarica solo chi scorre.
     - Niente doppioni (confronto per handle), niente animazione "reveal" di Prestige sui capi aggiunti (partirebbe
       gia' finita e li lascerebbe invisibili), immagini dei capi aggiunti sempre lazy (la Section Rendering API non
       conosce la posizione della sezione e le prime 3 arriverebbero "eager").
     - Mette la paginazione a pagine doppie (<template data-ndp-pager-virtual>) al posto di quella classica: subito
       se non c'e' una pagina da aggiungere, altrimenti solo DOPO averla aggiunta (se lo scaricamento fallisce resta
       la classica, cosi' nessuna pagina viene saltata).
     - Tornando indietro da un prodotto (back), se i capi erano stati aggiunti li riaggiunge e riporta lo scroll.
     - Filtri, ordinamento e cambio pagina di Prestige sostituiscono il contenuto della sezione (evento facet:update):
       un MutationObserver sulla sezione riaggancia tutto sulla griglia nuova, dopo lo scorrimento di Prestige.
     - Se lo scaricamento fallisce compare il pulsante "Mostra altri capi" (link normale alla pagina successiva).
  ----------------------------------------------------------------------------------------------------------------------
*/
(() => {
  'use strict';
  if (window.__ndpCollection) return;
  window.__ndpCollection = true;

  const ss = {
    get(key) { try { return JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (e) { return null; } },
    set(key, value) { try { sessionStorage.setItem(key, JSON.stringify(value)); } catch (e) { /* storage pieno o bloccato */ } }
  };

  const idle = (fn) => ('requestIdleCallback' in window) ? requestIdleCallback(fn, { timeout: 1500 }) : setTimeout(fn, 300);
  const afterLoad = (fn) => {
    if (document.readyState === 'complete') idle(fn);
    else window.addEventListener('load', () => idle(fn), { once: true });
  };

  let liveRegion = null;
  const announce = (message) => {
    if (!liveRegion) {
      liveRegion = document.createElement('p');
      liveRegion.style.cssText = 'position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0';
      liveRegion.setAttribute('role', 'status');
      liveRegion.setAttribute('aria-live', 'polite');
      document.body.appendChild(liveRegion);
    }
    liveRegion.textContent = '';
    setTimeout(() => { liveRegion.textContent = message; }, 60);
  };

  /* ================================================================================================================
     1. SCORCIATOIE TRA COLLEZIONI
     ================================================================================================================ */
  const COUNT_KEY = 'ndp_colnav_counts';
  const MENU_KEY = 'ndp_menu_counts';
  const AGE_PARAM = 'filter.v.option.taglia';
  /* 0-3 mesi, 6 mesi, taglia unica: il dominio 0-6 mesi del wizard (AGE_LAYETTE + TAGLIA_UNICA) */
  const LAYETTE = [
    'gid://shopify/FilterSettingGroup/165871946',
    'gid://shopify/FilterSettingGroup/143556938',
    'gid://shopify/FilterSettingGroup/203981130'
  ];

  /* Stessa forma di buildProbeUrl() del menu e di buildCountUrl() del wizard: path + ?view=wizard-exact + parametri */
  const probeUrlOf = (href) => {
    const q = href.indexOf('?');
    return q === -1 ? href + '?view=wizard-exact' : href.slice(0, q) + '?view=wizard-exact&' + href.slice(q + 1);
  };

  const probeCount = (url, cache) => {
    if (typeof cache[url] === 'number') return Promise.resolve(cache[url]);
    const menu = ss.get(MENU_KEY) || {};   /* riletta a ogni voce: il menu potrebbe averla appena contata */
    if (typeof menu[url] === 'number') {
      cache[url] = menu[url];
      return Promise.resolve(menu[url]);
    }
    const ctrl = ('AbortController' in window) ? new AbortController() : null;
    const timer = setTimeout(() => { if (ctrl) ctrl.abort(); }, 8000);
    return fetch(url, { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
      .then((response) => { if (!response.ok) throw new Error(String(response.status)); return response.text(); })
      .then((text) => {
        const count = parseInt(text.trim(), 10);
        if (Number.isNaN(count)) throw new Error('conteggio non valido');
        cache[url] = count;
        return count;
      })
      .catch(() => Infinity)   /* fail-open: nel dubbio la scorciatoia resta, e non si scrive in cache */
      .finally(() => clearTimeout(timer));
  };

  const runColnav = (nav) => {
    const run = (nav.__ndpRun || 0) + 1;
    nav.__ndpRun = run;
    const max = parseInt(nav.dataset.max, 10) || 5;
    const minValue = parseInt(nav.dataset.min, 10);
    const min = Number.isNaN(minValue) ? 9 : minValue;
    const all = Array.from(nav.querySelectorAll('.ndp-colnav__item'));
    const items = all.filter((item) => !item.hasAttribute('data-ndp-off'));   /* le spente non si contano ne' si mostrano */
    const cache = ss.get(COUNT_KEY) || {};
    const counts = new Array(items.length);
    let next = 0;
    let running = 0;
    let passing = 0;

    /* Le prime N (in ordine di priorita') con abbastanza capi; quelle mai controllate restano nascoste */
    const finish = () => {
      if (nav.__ndpRun !== run) return;   /* nel frattempo e' partito un conteggio piu' recente */
      let shown = 0;
      all.forEach((item) => {
        const index = items.indexOf(item);
        const ok = index !== -1 && counts[index] !== undefined && counts[index] >= min && shown < max;
        item.hidden = !ok;
        if (ok) shown += 1;
      });
      nav.hidden = shown === 0;
      ss.set(COUNT_KEY, cache);
    };

    if (min <= 0 || !items.length) {   /* soglia 0 = nessun conteggio: restano le prime N accese */
      counts.fill(Infinity);
      finish();
      return;
    }

    /* In ordine, 3 per volta, e ci si ferma appena ne bastano N: di solito N richieste, spesso zero (cache) */
    const pump = () => {
      while (running < 3 && next < items.length && passing < max) {
        const index = next++;
        const link = items[index].querySelector('a[href]');
        running += 1;
        probeCount(probeUrlOf(link.getAttribute('href')), cache).then((count) => {
          counts[index] = count;
          if (count >= min) passing += 1;
          running -= 1;
          if (running === 0 && (next >= items.length || passing >= max)) finish(); else pump();
        });
      }
    };
    pump();
  };

  const initColnav = (nav) => {
    if (nav.__ndpInit) return;
    nav.__ndpInit = true;
    afterLoad(() => runColnav(nav));
  };

  /* Cambio stagione da menu o wizard: il menu riscrive subito gli href; si riconta se la pagina resta */
  let seasonTimer = 0;
  document.addEventListener('ndp:state-changed', (event) => {
    if (!event.detail || event.detail.key !== 'season') return;
    clearTimeout(seasonTimer);
    seasonTimer = setTimeout(() => document.querySelectorAll('[data-ndp-colnav]').forEach(runColnav), 1500);
  });

  const sameSet = (a, b) => a.length === b.length && a.every((value) => b.includes(value));

  /* Query nella forma di buildUrl() del wizard: prima le taglie, poi filter.v.availability=1 */
  const withAges = (href, ages) => {
    const q = href.indexOf('?');
    const path = q === -1 ? href : href.slice(0, q);
    const params = ages.map((value) => AGE_PARAM + '=' + encodeURIComponent(value));
    params.push('filter.v.availability=1');
    return path + '?' + params.join('&');
  };

  /* Eta' dell'URL vero, stesse regole del Liquid. Serve in due momenti:
     - all'apertura: Shopify da' al Liquid solo le taglie che esistono in questa collezione (es. "6-12 mesi" del wizard
       senza i 9 mesi in Tutine): qui si rimettono tutte, cosi' la collezione di arrivo non perde capi;
     - dopo i filtri laterali di Prestige (facet:update), che cambiano la taglia senza ricaricare l'intestazione.
     La taglia unica va sempre insieme all'eta', come buildAgeParams() del wizard. */
  const TAGLIA_UNICA = LAYETTE[2];
  const syncColnavAge = (recount) => {
    document.querySelectorAll('[data-ndp-colhead]').forEach((head) => {
      let ages = new URLSearchParams(location.search).getAll(AGE_PARAM);
      if (ages.length && !ages.includes(TAGLIA_UNICA)) ages.push(TAGLIA_UNICA);
      if (!ages.length && head.hasAttribute('data-ndp-self-layette')) ages = LAYETTE.slice();
      const before = (head.dataset.ndpAge || '').split(',').filter(Boolean);
      if (sameSet(ages, before)) return;
      head.dataset.ndpAge = ages.join(',');

      const ageLink = head.querySelector('[data-ndp-age-link]');
      if (ageLink) ageLink.setAttribute('href', withAges(ageLink.getAttribute('href'), ages));

      const nav = head.querySelector('[data-ndp-colnav]');
      if (!nav) return;
      const layetteOk = ages.every((value) => LAYETTE.includes(value));
      nav.querySelectorAll('.ndp-colnav__item').forEach((item) => {
        const link = item.querySelector('a[href]');
        if (!link) return;
        const flags = (link.dataset.ndpFlags || '').split(',');
        const isLayette = flags.includes('layette');
        if (isLayette && ages.length && !layetteOk) item.setAttribute('data-ndp-off', '');
        else item.removeAttribute('data-ndp-off');
        let chipAges = [];
        if (!flags.includes('noage')) chipAges = ages.length ? ages : (isLayette ? LAYETTE : []);
        link.setAttribute('href', withAges(link.getAttribute('href'), chipAges));
      });
      if (recount) runColnav(nav);
    });
  };

  /* ================================================================================================================
     2. ALTRI 50 CAPI ALLO SCORRIMENTO + PAGINAZIONE A PAGINE DOPPIE
     ================================================================================================================ */
  const STATE_KEY = 'ndp_more_state';
  const TRIGGER_AT = 0.6;

  const isBackForward = () => {
    const entry = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    return !!entry && entry.type === 'back_forward';
  };

  /* Dopo un cambio pagina/filtro Prestige riporta su la griglia con uno scorrimento morbido: si aspetta che finisca
     (scrollend, al massimo 2 secondi), altrimenti dal fondo della pagina vecchia il 60% risulterebbe gia' raggiunto */
  const whenScrollSettles = (fn) => {
    const start = performance.now();
    let done = false;
    let timer = 0;
    const go = () => {
      if (done) return;
      done = true;
      window.removeEventListener('scrollend', onEnd);
      clearTimeout(timer);
      fn();
    };
    const onEnd = () => { if (performance.now() - start > 400) go(); };
    window.addEventListener('scrollend', onEnd);
    timer = setTimeout(go, 2000);
  };

  const initMore = (section, afterUpdate) => {
    const list = section.querySelector('product-list');
    if (!list || list.__ndpMore) return;
    list.__ndpMore = true;

    /* Paginazione a pagine doppie al posto di quella classica */
    const useVirtualPager = () => {
      const template = section.querySelector('template[data-ndp-pager-virtual]');
      const classic = section.querySelector('[data-ndp-pager]');
      if (template && classic) classic.replaceWith(template.content.cloneNode(true));
    };

    /* Ricorda posizione e stato quando si apre un prodotto, per ritrovarli tornando indietro */
    list.addEventListener('click', (event) => {
      if (!event.target.closest('a[href]')) return;
      ss.set(STATE_KEY, { href: location.href, appended: list.dataset.ndpAppended === '1', y: window.scrollY, t: Date.now() });
    }, true);

    const more = section.querySelector('[data-ndp-more]');
    if (!more) {
      /* Ultima pagina: le pagine doppie solo se e' dispari (1, 3, 5...). Su un'ultima pagina pari (es. 2 di 2, arrivando
         da Google) la doppia sarebbe "1 di 1" senza via per tornare indietro: resta la paginazione classica. */
      const template = section.querySelector('template[data-ndp-pager-virtual]');
      if (template && parseInt(template.dataset.page, 10) % 2 === 1) useVirtualPager();
      return;
    }
    more.classList.add('is-auto');
    more.hidden = false;
    const text = more.querySelector('.ndp-more__text');
    const button = more.querySelector('.ndp-more__button');
    let state = 'idle';
    let pending = null;
    let focusNew = false;

    const load = () => {
      if (state === 'loading') return pending;
      if (state === 'done') return Promise.resolve();
      state = 'loading';
      more.classList.add('is-loading');
      if (text) text.textContent = more.dataset.loading || '';

      const url = new URL(more.dataset.nextUrl, location.origin);
      url.searchParams.set('section_id', more.dataset.sectionId);

      pending = fetch(url.toString(), { credentials: 'same-origin' })
        .then((response) => { if (!response.ok) throw new Error(String(response.status)); return response.text(); })
        .then((html) => {
          if (!list.isConnected) return;   /* nel frattempo la griglia e' stata sostituita (filtri) */
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const seen = new Set(Array.from(list.querySelectorAll('product-card'), (card) => card.getAttribute('handle')));
          const fragment = document.createDocumentFragment();
          let added = 0;
          doc.querySelectorAll('product-list > product-card').forEach((card) => {
            const handle = card.getAttribute('handle');
            if (!handle || seen.has(handle)) return;
            seen.add(handle);
            card.removeAttribute('reveal-on-scroll');
            card.querySelectorAll('img').forEach((img) => {
              img.setAttribute('loading', 'lazy');
              if (img.getAttribute('fetchpriority') === 'high') img.removeAttribute('fetchpriority');
            });
            fragment.appendChild(document.importNode(card, true));
            added += 1;
          });
          const firstNew = fragment.firstElementChild;
          list.appendChild(fragment);
          list.dataset.ndpAppended = '1';
          state = 'done';
          more.remove();
          useVirtualPager();
          if (added) announce((more.dataset.loaded || '').replace('{n}', String(added)));
          /* Chi ha usato il pulsante (tastiera o lettore di schermo) prosegue dal primo capo nuovo */
          if (focusNew && firstNew) {
            const target = firstNew.querySelector('a[href]');
            if (target) target.focus({ preventScroll: true });
          }
        })
        .catch(() => {
          state = 'error';
          more.classList.remove('is-auto', 'is-loading');   /* compare il pulsante "Mostra altri capi" */
        });
      return pending;
    };

    if (button) {
      button.addEventListener('click', (event) => {
        if (state === 'error') state = 'idle';
        event.preventDefault();
        focusNew = true;
        load();
      });
    }

    /* Tornati indietro da un prodotto: riaggiunge subito i capi e riporta lo scroll dove era */
    const saved = ss.get(STATE_KEY);
    if (!afterUpdate && saved && saved.appended && saved.href === location.href && isBackForward() && Date.now() - (saved.t || 0) < 3600000) {
      load().then(() => { if (state === 'done' && typeof saved.y === 'number') window.scrollTo(0, saved.y); });
      return;
    }

    const cards = list.querySelectorAll(':scope > product-card');
    const trigger = cards[Math.max(0, Math.ceil(cards.length * TRIGGER_AT) - 1)] || more;
    if (!('IntersectionObserver' in window)) {
      more.classList.remove('is-auto');
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        observer.disconnect();
        load();
      }
    }, { rootMargin: '0px 0px 400px 0px' });
    if (afterUpdate) whenScrollSettles(() => { if (list.isConnected) observer.observe(trigger); });
    else observer.observe(trigger);
  };

  const watchSection = (section) => {
    if (section.__ndpWatch) return;
    section.__ndpWatch = true;
    new MutationObserver(() => {
      initMore(section, true);
      syncColnavAge(true);
    }).observe(section, { childList: true });
  };

  const init = () => {
    syncColnavAge(false);   /* prima dei conteggi, che partono dopo il load */
    document.querySelectorAll('[data-ndp-colnav]').forEach(initColnav);
    document.querySelectorAll('.shopify-section--main-collection').forEach((section) => {
      initMore(section);
      watchSection(section);
    });
  };

  init();
})();
